/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_UnavailableInputs */

const en_us2_coaching_unavailable = /** @type {(inputs: Coaching_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No connection. This part needs the internet.`)
};

const pt_br2_coaching_unavailable = /** @type {(inputs: Coaching_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão. Esta parte precisa da internet.`)
};

const pt_pt2_coaching_unavailable = /** @type {(inputs: Coaching_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão. Esta parte precisa da internet.`)
};

/** @type {(inputs: Coaching_UnavailableInputs) => LocalizedString} */
const es_419_coaching_unavailable = en_us2_coaching_unavailable;

/** @type {(inputs: Coaching_UnavailableInputs) => LocalizedString} */
const fr_fr2_coaching_unavailable = en_us2_coaching_unavailable;

/** @type {(inputs: Coaching_UnavailableInputs) => LocalizedString} */
const de_de2_coaching_unavailable = en_us2_coaching_unavailable;

/** @type {(inputs: Coaching_UnavailableInputs) => LocalizedString} */
const it_it2_coaching_unavailable = en_us2_coaching_unavailable;

/**
* | output |
* | --- |
* | "No connection. This part needs the internet." |
*
* @param {Coaching_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_unavailable = /** @type {((inputs?: Coaching_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_unavailable(inputs)
	if (locale === "es-419") return es_419_coaching_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_unavailable(inputs)
	if (locale === "de-DE") return de_de2_coaching_unavailable(inputs)
	if (locale === "it-IT") return it_it2_coaching_unavailable(inputs)
	return en_us2_coaching_unavailable(inputs)
});
export { coaching_unavailable as "coaching.unavailable" }